import {
	API_GET_SAFEPLACE_APPOINTMENT,
	API_POST_USE_SAFEPLACE_QRCODE,
	API_POST_CANCEL_SAFEPLACE_QRCODE,
	API_POST_TERMINATE_SAFEPLACE_QRCODE,
	API_GET_ALL_SAFEPLACE_QRCODE,
	SET_QR_SEARCH,
} from "actions/safeplace";

export function getSafePlaceAppointment(qrcode) {
	return {
		type: API_GET_SAFEPLACE_APPOINTMENT,
		payload: {
			request: {
				url: `/safeplace`,
				params: {
					qrcode,
				},
			},
		},
	};
}

export function useSafePlaceQR(qrcode, centerId) {
	return {
		type: API_POST_USE_SAFEPLACE_QRCODE,
		payload: {
			request: {
				url: `/safeplaceUseQR`,
				method: "POST",
				data: { qrcode: qrcode, centerId: centerId },
			},
		},
	};
}

export function cancelSafePlaceQR(qrcode, centerId) {
	return {
		type: API_POST_CANCEL_SAFEPLACE_QRCODE,
		payload: {
			request: {
				url: `/safeplaceCancelQR`,
				method: "POST",
				data: { qrcode: qrcode, centerId: centerId },
			},
		},
	};
}

export function terminateSafePlaceQR(qrcode, centerId) {
	return {
		type: API_POST_TERMINATE_SAFEPLACE_QRCODE,
		payload: {
			request: {
				url: `/safeplaceCloseQR`,
				method: "POST",
				data: { qrcode: qrcode, centerId: centerId },
			},
		},
	};
}

export function getAllSafePlaceQR(search) {
	return {
		type: API_GET_ALL_SAFEPLACE_QRCODE,
		payload: {
			request: {
				url: `/appointments/safeplace`,
				params: {
					search,
				},
			},
		},
	};
}

export function qrSearch(qr) {
	return {
		type: SET_QR_SEARCH,
		data: qr,
	};
}
